import { render } from "./total_time_card.svg?vue&type=template&id=d38478f4"
const script = {}
script.render = render

export default script